import { firebase } from '../firebase-config';
import { collection, getDocs, query, where} from 'firebase/firestore';
import { COLLECTIONS } from '../config';

/**
 * Get Data from USER_ACTIVITY_LOG collection
 * @param {Array} userIds - Array of user IDs to fetch data for
 * @param {Function} onSuccess - Callback function for successful retrieval
 * @param {Function} onError - Callback function for handling errors
 */

export async function getUserActivity(companyId, empName) {
  const colRef = collection(firebase, COLLECTIONS.USER_ACTIVITY_LOG);

  const constraints = [where("companyId", "==", companyId)];
  const results = [];

  const isAllUsers = !empName || empName === "All" || (Array.isArray(empName) && empName.length === 0);

  try {
    if (isAllUsers) {
      const q = query(colRef, ...constraints);
      const snapshot = await getDocs(q);
      snapshot.forEach((doc) => {
        results.push({ id: doc.id, ...doc.data() });
      });
    } else if (Array.isArray(empName)) {
      const batches = [];
      for (let i = 0; i < empName.length; i += 10) {
        const batch = empName.slice(i, i + 10);
        const q = query(colRef, ...constraints, where("userId", "in", batch));
        batches.push(getDocs(q));
      }

      const snapshots = await Promise.all(batches);
      snapshots.forEach((snapshot) => {
        snapshot.forEach((doc) => {
          results.push({ id: doc.id, ...doc.data() });
        });
      });
    }

    return results;
  } catch (error) {
    console.error("Error getting user activity: ", error);
    throw error;
  }
}
